import React from "react";

interface propsTypes {
  children?: React.ReactNode;
  className?: string;
}

const Footer = (props: propsTypes) => {
  const { children  } = props;
  return <footer {...props}> {children}</footer>;
};

export default Footer;
